import { FC } from 'react'
import styled from 'styled-components'
import {
  compose,
  variant,
  space,
  layout,
  color,
  typography,
  border,
  textStyle,
  position,
  system,
  flexbox,
  SpaceProps,
  LayoutProps,
  ColorProps,
  TypographyProps,
  BorderProps,
  TextStyleProps,
  PositionProps,
  FlexboxProps,
} from 'styled-system'
import { colorsWithOpacity, backgroundGradient } from 'utils'
export interface BaseTypoProps
  extends Omit<React.HtmlHTMLAttributes<HTMLHeadingElement>, `color`>,
    SpaceProps,
    LayoutProps,
    ColorProps,
    TypographyProps,
    BorderProps,
    TextStyleProps,
    PositionProps,
    FlexboxProps {
  onClick?: () => void
  textDecoration?: string
  textTransform?: string
  whiteSpace?: string
  textOverflow?: string
}
const Typography: FC<BaseTypoProps> = styled.h1<BaseTypoProps>`
  margin: 0;
  ${compose(
    space,
    variant,
    layout,
    color,
    typography,
    border,
    position,
    textStyle,
    flexbox,
    colorsWithOpacity,
    backgroundGradient,
    system({
      textDecoration: true,
      textTransform: true,
      whiteSpace: true,
      textOverflow: true,
    }),
  )}
  ${({ onClick = null }) => `
    ${onClick == null ? `` : `  cursor: pointer`};
  `}
`

Typography.defaultProps = {
  maxWidth: `100%`,
}

const Typo: FC<BaseTypoProps> = ({
  children,
  textStyle = `general`,
  ...props
}) => {
  return (
    <Typography textStyle={textStyle} {...props}>
      {children}
    </Typography>
  )
}

export default Typo
